// extracted by mini-css-extract-plugin
export default {"box":"PopularCategories_box__MQb-6","icon":"PopularCategories_icon__oBDEP","container":"PopularCategories_container__R+wE+"};